$(document).ready(function () {
    $('.bn_commerce-pe__form-uploader-input').on('change', function () {
        let valid = true,
            input = $(this),
            totalCount = this.files.length,
            maxSize = input.data('max-size'),
            maxError = input.data('max-error'),
            container = input.parents('.form-group'),
            error = container.find('.help-block'),
            formData = new FormData();

        for (let i = 0; i < totalCount; i++) {
            formData.append('attachment', this.files[i]);

            if (this.files[i].size > parseInt(maxSize)) {
                valid = false;

                error.text(maxError);
            }
        }

        if (valid) {
            formData.append('sign', $('.bn_commerce-pe__sign').val());

            $.ajax({
                url: '/account/commerce/payouts/attachment-upload',
                type: 'post',
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {
                    input.val('')

                    if (response.error) {
                        error.text(response.error);
                    } else {
                        error.text('');

                        $('.bn_commerce-pe__form-attachment-wrapper').append(response)
                    }
                },
            });
        }
    });

    $(document).on('click', '.bn_commerce-pe__form-attachment-delete', function () {
        let that = $(this),
            attachment = that.parents('.bn_commerce-pe__form-attachment'),
            id = attachment.attr('data-id'),
            sign = $('.bn_commerce-pe__sign').val();

        $.ajax({
            url: '/account/commerce/payouts/attachment-delete',
            type: 'post',
            data: {'id': id, 'sign': sign},
            dataType: 'json',
            success: function(response){
                if (response === true) {
                    attachment.remove();
                }
            },
        });
    });
})